import {Inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {API_URL} from "@core/tokens/api.token";
import { HttpClient } from "@angular/common/http";
import {Newsletter} from "@app/interfaces/newsletter";

@Injectable({providedIn: 'root'})
export class NewsletterService {

  constructor(
    @Inject(API_URL) private apiUrl: string,
    private http: HttpClient
  ) {}

  addSubscriber(body: Newsletter): Observable<Newsletter> {
    const path = `${this.apiUrl}/newsletter`;
    return this.http.post<Newsletter>(path, body);
  }
}
